export const OpenDetail = 'open_detail'
export const CloseDetail = 'close_detail'
export const AddToCart = 'add_product_to_cart'
export const AddToCart2 = 'add_product_to_cart2'
export const CheckStock = 'check_stock'
export const Checkout = 'checkout'
export const ShoppingCartShow = 'shopping_cart_show'
export const ShoppingCartClose = 'shopping_cart_close'
export const SetIframeHeight = 'set_iframe_height'
export const OpenNewWindow = 'open_new_window'
export const EmptyCart = 'empty_cart'
export const SetCartLbl = 'set_cart_lbl'
export const UpdateShopCartLabel = 'update_shop_cart_label'
export const ShakeCartAndAdd = 'shake_cart'
export const AnimateCartAndAdd = 'animate_cart'
export const ResponseCartOffset = 'response_cart_offset'
export const RequestCartOffset = 'request_cart_offset'
export const RequestCartAmount = 'request_cart_amount'
export const ResponseCartAmount = 'reqsponse_cart_amount'
export const InstantCheckout = 'instant_checkout'
export const GetSettings = 'get_settings'
export const GetIdentity = 'ide'
export const TrackAddCart = 'track_addcart'
export const ShowAlert = 'alert'
export const CheckoutFinished = 'checkout_finished'
export const ClearCartContents = 'clear_cart_contents'
export const CartFinishedLoading = 'cart_finished-loading'
